import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { TenantRouteKey } from './features';
import { useTenant } from './TenantProvider';

interface TenantRouteGuardProps {
  route: TenantRouteKey;
  children: JSX.Element;
  fallbackTo?: string;
}

const TenantRouteGuard = ({
  route,
  children,
  fallbackTo = '/dashboard',
}: TenantRouteGuardProps) => {
  const location = useLocation();
  const { isRouteVisible } = useTenant();

  if (!isRouteVisible(route)) {
    return <Navigate to={fallbackTo} replace state={{ from: location }} />;
  }

  return children;
};

export default TenantRouteGuard;
